export const COLOR_DEFAULT_CLEAR_BG = 0x1118a7;
export const COLOR_DEFAULT_FOG_START = 0x0b48cc;
export const COLOR_DEFAULT_FOG_END = 0x0195fd;

export const DEFAULT_BG_GRADIENT = {
    colors: [0x1118a7, 0x00a2ff],
    ratios: [-0.05, 0.95],
    rotate: 90 + 80,
    fixChubb: true
};

export const COLOR_DEFAULT_TEXT = 0xffffff;
export const COLOR_SCORE_TEXT = 0x1a37c1;
export const COLOR_DEFAULT_BUTTON = 0xffffff;
export const COLOR_DEFAULT_BUTTON_TEXT = 0x1760d8;

export const COLOR_QUESTION_HEADING_BG = 0x1a37c1;
export const COLOR_QUESTION_BLOCK_BG = 0x3166f2;
export const COLOR_COMMENT_BLOCK_BG = 0x3166f2;

export const COLOR_OPTION_BUTTON_DEFAULT = 0xadc2fa;
export const COLOR_OPTION_BUTTON_DEFAULT_TEXT = 0x1a37c1;
export const COLOR_OPTION_BUTTON_HOVER = 0xffffff;
export const COLOR_OPTION_BUTTON_CORRECT = 0xffffff;
export const COLOR_OPTION_BUTTON_NOT_BAD = 0xccd4e6;
export const COLOR_OPTION_BUTTON_WORST = 0xe62632;
export const COLOR_OPTION_BUTTON_WORST_TEXT = 0xffffff;
